import { Flex, Text } from "@theme-ui/components"
import React from "react"
import { ArrowRight } from "react-feather"

const ArrowLink = ({ anchor, dark }) => (
  <Flex sx={{ alignItems: "center" }}>
    <Flex color={dark ? "light" : "primary"} sx={{ marginRight: 2 }}>
      <ArrowRight size={32} />
    </Flex>
    <Text
      sx={{ textTransform: "lowercase", color: dark ? "light" : "primary" }}
    >
      {anchor}
    </Text>
  </Flex>
)

export default ArrowLink
